import { createPath } from "rd-url-utils";

export const rootPageUrl = createPath("/");
export const AppPageUrl = createPath("/app");
export const DashboardUrl = createPath<{ clientId: string }>("/app/:clientId");
export const UsersPageUrl = createPath<{ clientId: string }>("/app/:clientId/users");
export const CampaignUrl = createPath<{ clientId: string }>("/app/:clientId/campaigns/new");

export const EditCampaignUrl = createPath<{
    clientId: string;
    campaignId: string;
    mode: "edit" | "summary" | "update";
}>("/app/:clientId/campaigns/:campaignId");

export const CreateClientUrl = createPath<{ clientId: string }>("/app/:clientId/createClient");
export const LogoutPageUrl = createPath<{}>("/signed-out");
export const MobilePageUrl = createPath<{}>("/mobile");
// export const ReportsUrl = createPath("/reports");

export type ReportTabType = "dynamic" | "creative" | "audience" | "geographic";

export interface ReportParams {
    campaignId?: string;
    clientId: string;
    tab: ReportTabType;
}

export interface ReportQuery {
    fromDate?: string;
    toDate?: string;
}

export const ReportUrl = createPath<ReportParams, ReportQuery>(`/app/:clientId/reports/:tab/:campaignId?`);
